// Constants
import { Colors } from "@ms/uno-constants/lib/local/Colors";
// Models
// Styles
import { concatStyleSets, FontSizes, FontWeights, memoizeFunction, mergeStyles } from "@fluentui/react";
import { highContrastBorders } from "../../../utilities/HighContrast.styles";
import { flexChildSizeFixed, flexParent, fontColorNeutralSecondary, labelStyle, submitFormButton, textClip } from "../../../utilities/Mixin.styles";
/**
 * Helper to get styles for CommentThreadView
 * @param theme Planner theme
 * @param customStyles Any custom style overrides
 */ export const getStyles = memoizeFunction((theme, customStyles)=>{
    const root = [
        flexParent("column"),
        {
            paddingTop: "20px",
            paddingBottom: "5px",
            "> *": flexChildSizeFixed()
        }
    ];
    const threadViewLabel = labelStyle(theme);
    const newCommentSection = [
        flexParent("column"),
        {
            "> *": flexChildSizeFixed(),
            "> .commentLoadError": [
                fontColorNeutralSecondary(theme),
                {
                    fontSize: FontSizes.small
                }
            ]
        }
    ];
    const commentBox = [
        highContrastBorders()
    ];
    const sendCommentButton = [
        flexChildSizeFixed(),
        submitFormButton(theme),
        {
            alignSelf: "flex-end",
            margin: "12px 0px 15px",
            fontSize: FontSizes.small,
            fontWeight: FontWeights.semibold
        }
    ];
    const expandCommentsSection = [
        textClip(),
        {
            marginTop: "20px",
            padding: "10px 0px",
            textAlign: "center",
            color: Colors.ThemeSecondary,
            borderTop: "1px solid",
            cursor: "pointer"
        }
    ];
    const CommentThreadViewStyles = {
        root,
        threadViewLabel,
        newCommentSection,
        commentBox,
        sendCommentButton,
        expandCommentsSection
    };
    return concatStyleSets(CommentThreadViewStyles, customStyles);
});
/**
 * Get the classnames associated with the computed styles
 * @param styles The styles for the component
 */ export const getClassNames = memoizeFunction((styles)=>({
        root: mergeStyles("commentThreadView", styles.root),
        threadViewLabel: mergeStyles("threadViewLabel", styles.threadViewLabel),
        newCommentSection: mergeStyles("newCommentSection", styles.newCommentSection),
        commentBox: mergeStyles("commentBox", styles.commentBox),
        sendCommentButton: mergeStyles("sendCommentButton", styles.sendCommentButton),
        expandCommentsSection: mergeStyles("expandCommentsSection", styles.expandCommentsSection)
    }));
